import { CancelToken } from '@/app/shared/command-queue'
import { err, ok } from '@xlearn/common'
import { waitToLoad, WaitToLoadError } from '@/app/shared/utils'
import { PracticeStoreModule, FindPracticeError } from '@/app/practice/store'

export type LoadPracticeError = WaitToLoadError | FindPracticeError

export class LoadPracticeJob {

  constructor(private practiceStore: PracticeStoreModule) { }

  async execute(practiceId: string, cancel: CancelToken) {
    const result = await waitToLoad(() => this.practiceStore.loadingPhase === 'loaded', cancel)
    if (!result.success) {
      return err(result.error as LoadPracticeError)
    }

    const findResult = this.practiceStore.findPractice(practiceId)
    if (!findResult.success) {
      return findResult
    }

    const practice = findResult.value
    return ok(practice)
  }

}
